exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.Companies-List {\n  height: 325px;\n  overflow: scroll;\n  border: solid 1px #757575;\n}\n.Company-Cell {\n  width: 100%;\n  height: 48px;\n}\n", ""]);

